import { checkTrend, validatorSsn } from 'src/features/ApplicationWorkflows/SBAPPP/utilities';
import { normalizeNumber } from "src/utilities/formatNumbers"
import {
  equals,
  isEmpty,
  insert,
  pipe,
  lte,
  join,
  findIndex,
  gte,
  toUpper,
  replace,
  head,
  last,
  splitAt,
  length,
} from 'ramda';
import { numbericRegex } from './regex';
const tinRegex = /^[0-9-]*$/;
import { phoneNumberFormatter } from 'src/utilities/borrowers';
import { redactTheTextFn } from './redact';
const tinRegexFormat = /^\d{2}-\d{1,10}$/;



export const tinFormattorFn = (number: any) => {
  if (!isEmpty(number) && !tinRegex.test(number)) {
    return undefined;
  }
  const normalizeValue = normalizeNumber(number);
  const lenOfNumber: number = normalizeValue.length;
  const f1 = dashInsertorFn(2);

  switch (true) {
    case equals(lenOfNumber, 1) || equals(lenOfNumber, 2):
      return normalizeValue;
    case gte(lenOfNumber, 3) && lte(lenOfNumber, 10):
      return f1(normalizeValue);
    default:
      return tinRegexFormat.test(number) || isEmpty(number)
        ? number
        : undefined;
  }
};

const dashInsertorFn = (at: number | any) => {
  return pipe(insert(at, '-'), join('')) as any;
};

// ssnFormatter is used for auto format SSN
// SSN (XXX-XX-XXXX) form of 9 digits separted by two dashes at after 3rd digit and 5th digit
export const ssnFormatter = (number: any) => {
  if (!isEmpty(number) && !tinRegex.test(number) && !validatorSsn(number)) {
    return undefined;
  }
  const normalizeValue = normalizeNumber(number);
  const lenOfNumber: number = normalizeValue.length;
  const f1 = dashInsertorFn(3);
  const f2: any = pipe(f1, dashInsertorFn(6));
  switch (true) {
    case equals(lenOfNumber, 4) || equals(lenOfNumber, 5):
      return f1(normalizeValue);
    case gte(lenOfNumber, 6) && lte(lenOfNumber, 9):
      return f2(normalizeValue);
    case equals(lenOfNumber, 3):
      return normalizeNumber(number);
    default:
      return numbericRegex.test(number) || isEmpty(number) ? number : undefined;
  }
};
export const naFormatter = (value: any) => {
  return replace(/[^NA]/g, '', toUpper(value));
};

// tinOrEinOrSSNFormatter used for Sprinkle onChange
// return value if it match tin pattern otherwise return undefined
// this will avoid onChange set if the return is undefined
export const tinOrEinOrSSNFormatter = (number: any) => {
  return equals(findIndex(equals('-'), number), 2)
    ? tinFormattorFn(number)
    : ssnFormatter(number);
};
export const phoneNumberOrNA = (value: any) => {
  const phoneNumRegex = /^[0-9\ \-\(\)]+$/;
  return equals(phoneNumRegex.test(value), true)
    ? phoneNumberFormatter(value)
    : naFormatter(value);
};

export const isoTinFormattorFn = (number: any) => {
  if (!isEmpty(number) && !tinRegex.test(number) && checkTrend(number)) {
    return undefined;
  }

  const normalizeValue = normalizeNumber(number);
  const lenOfNumber: number = normalizeValue.length;
  const f1 = dashInsertorFn(2);
  const f2: any = pipe(f1);
  switch (true) {
    case equals(lenOfNumber, 4) || equals(lenOfNumber, 5):
      return f1(normalizeValue);
    case gte(lenOfNumber, 6) && lte(lenOfNumber, 9):
      return f2(normalizeValue);
    case equals(lenOfNumber, 3):
      return normalizeNumber(number);
    default:
      return numbericRegex.test(number) || isEmpty(number) ? number : undefined;
  }
};



export const itinFormatterFn = (number: any): string | undefined => {
  const itinRegex = /^9\d{2}(7\d|8\d|9[0-2]|9[4-9])\d{4}$/;
  const numbericRegex = /^\d+$/;
  const normalize = (str: string) => str.replace(/\D/g, '');
  const input = normalize(number);

  if (!isEmpty(input) && !itinRegex.test(input)) {
    return undefined;
  }

  const len = input.length;

  if (len === 3) return input;
  if (len === 4 || len === 5) return `${input.slice(0, 3)}-${input.slice(3)}`;
  if (len >= 6 && len <= 9) return `${input.slice(0, 3)}-${input.slice(3, 5)}-${input.slice(5)}`;
  if (numbericRegex.test(input) || isEmpty(input)) return number;

  return undefined;
};

export const redactSSN = (ssn: string | any) => {
  if (ssn && length(ssn) > 8) {
    const splited = splitAt(7, ssn);
    const redactText = head(splited);
    const remainingText = last(splited);
    return `${redactTheTextFn(redactText, 'X')}${remainingText}`;
  }
  return ssn;
};
